import script from "./UiSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./UiSidebar.vue?vue&type=style&index=0&id=2140eb92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2140eb92"]])

export default __exports__